import { TranslateService } from './../../shared/translate/translate.service';
import { AuthService } from './../../shared/models/auth.service';
import { Component, OnInit, ViewChild, Input, Output, EventEmitter, OnChanges } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Router } from '@angular/router';
import { WeGoConfig, IAPIResponse, ApplicationRouteURL, UserRoles, DataListModel } from '../../shared/config';
import { OrganizationSubscriptionModel, SubscriptionModel } from '../models/organization-subscription.model';
import { OrganizationSubscriptionService } from '../models/organization-subscription.service';

@Component({
  selector: 'wego-assign-subscription-to-organization-popup',
  template: require('../views/organization-subscription-popup.component.html'),
})

export class AssignOrganizationSubscriptionPopupComponent implements OnInit, OnChanges {
  DataListModel: DataListModel;
  subscriptionList: SubscriptionModel[];
  organizationSubscriptionModel: OrganizationSubscriptionModel;
  message: string;
  apiErrorMsg: string;
  isLoading: boolean;
  isParentCheck: boolean;
  LblAssignSubscription: string;
  LblIcon: string;

  public OrganizationHashId: string;
  @Output('OnSuccessSelect') onSuccessSelect = new EventEmitter();
  @ViewChild('subscriptionModel') public subscriptionModel: any;


  get isAnyChecked(): boolean {
    if (this.subscriptionList) {
      let isCheck = this.subscriptionList.some(x => x.isChecked == true);
      if (isCheck) {
        if (this.subscriptionList.every(x => x.isChecked == true))
          this.isParentCheck = true;
        else
          this.isParentCheck = false;
      }
      else {
        this.isParentCheck = false;
      }
      return isCheck;
    }
    else {
      this.isParentCheck = false;
      return false;
    }
  }
  constructor(
    private organizationSubscriptionService: OrganizationSubscriptionService
    , private authService: AuthService
    , private router: Router, private translate: TranslateService) { }

  ngOnInit() {
    this.LblAssignSubscription = this.translate.instant('LblAssign') + this.translate.instant('LblSubscription');
    this.LblIcon = 'fa fa-plus-square';
    this.DataListModel = new DataListModel();
    this.DataListModel.searchField = ["name","groupName", "timeInterval", "invoiceInterval", "paymentInterval"];
  }

  ngOnChanges(change: any) {
    console.log(change);
  }

  public show(): void {
    this.DataListModel.currentPage = 1;
    this.DataListModel.totalItems = 0;
    this.DataListModel.sortType = "";
    this.DataListModel.sortReverse = null;
    this.DataListModel.searchTerm = "";
    this.DataListModel.infoMessage = "";
    this.GetSubscriptionListForOrganization();
    this.subscriptionModel.show();
  }

  public hide(): void {
    this.subscriptionModel.hide();
  }

  private GetSubscriptionListForOrganization() {
    this.isLoading = true;
    this.organizationSubscriptionService.GetSubscriptionListByOrganizationToInstance(this.OrganizationHashId, this.DataListModel)
      .subscribe(
      res => {
        this.subscriptionList = res.data;
        this.DataListModel.totalItems = res.totalRecords;
        this.DataListModel.infoMessage = res.error;
        this.isLoading = false;
      },
      error => {
        this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
        this.isLoading = false;
      });
  }
  public OnParentCheck(isChecked: boolean) {
    this.subscriptionList.forEach(x => x.isChecked = isChecked);
  }
  private select(subscriptionHashId: string): void {
    this.isLoading = true;
    let model = new OrganizationSubscriptionModel();
    model.subscriptionHashId = subscriptionHashId;
    model.organizationHashId = this.OrganizationHashId;
    this.organizationSubscriptionService.AssignSubscriptionToOrganization(model)
      .subscribe(
      res => {
        this.message = this.translate.instant('LblRecordSavedSuccess')
        this.OnSuccessSelect();
        this.isLoading = false;
      },
      error => {
        this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
        this.isLoading = false;
      },
      () => {
        this.subscriptionModel.hide();
        this.isLoading = false;
      });
  }

  private OnSort(sortName: string) {
    this.DataListModel.sortType = sortName;
    this.DataListModel.sortReverse = !this.DataListModel.sortReverse;
    this.GetSubscriptionListForOrganization();
  }

  private OnSearch(event: any) {
    this.DataListModel.searchTerm = event.searchTerm;
    this.DataListModel.currentPage = 1;
    this.GetSubscriptionListForOrganization();
  }

  private OnPageChanged(event: any): void {
    this.DataListModel.currentPage = event.page;
    this.GetSubscriptionListForOrganization();
  };

  public OnPagingChange(event: any) {
    console.log(this.DataListModel);
    this.DataListModel.currentPage = 1;
    this.DataListModel.totalItems = 0;
    this.DataListModel.itemsPerPage = event.itemPerPage;
    this.GetSubscriptionListForOrganization();
  }
  private OnSuccessSelect() {
    this.onSuccessSelect.emit({ SuccessMessage: this.message })
  }

  private OnAdd(event: any) {
    let subscriptionHashIdList: any[];
    subscriptionHashIdList = this.subscriptionList.filter(x => x.isChecked).map(x => x.sharedVehicleSubscriptionHashId);
    this.isLoading = true;
    let model = new OrganizationSubscriptionModel();
    model.listOfSubscriptionHashId = subscriptionHashIdList;
    model.organizationHashId = this.OrganizationHashId;
    this.organizationSubscriptionService.AssignSubscriptionToOrganization(model)
      .subscribe(
      res => {
        this.message = this.translate.instant('LblRecordSavedSuccess')
        this.OnSuccessSelect();
        this.isLoading = false;
      },
      error => {
        this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
        this.isLoading = false;
      },
      () => {
        this.subscriptionModel.hide();
        this.isLoading = false;
      });

  }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/organizationsubscription/components/organization-subscription-popup.component.ts